<div
  class="banner d-lg-block d-none"
  [ngClass]="{ 'banner-home': isHomeBanner }"
  *ngIf="memberName || pageTitle"
>
  <!-- <img class="banner-bg-layer" [src]="'banner/desktop-banner.png' | contentAssetImage" alt="" *ngIf="!isHomeBanner" /> -->
  <div class="container banner-container h-100 d-flex flex-row align-items-center justify-content-between position-relative">
    <ng-container *ngIf="isHomeBanner; else defaultTitleTemplate">
      <div class="d-flex flex-column banner-welcome-text">
        <a class="d-flex align-items-center gap-2 banner-welcome-link" [routerLink]="['/account']">
          <span class="banner-welcome-name mb-0">
            {{ 'home.page.banner.welcome' | translate: { fgbdefault: 'Welcome' } }}, {{ memberName }}!
          </span>
          <span class="material-icons banner-welcome-chevron">chevron_right</span>
        </a>
        <div class="banner-membership-label" *ngIf="memberCard$ | async as memberCard">
          {{ 'member.card.id.label' | translate: { fgbdefault: 'ID' } }}: {{ memberCard.MemberId }}
        </div>
      </div>
    </ng-container>
    <ng-template #defaultTitleTemplate>
      <h1 class="banner-title text-white mb-0">
        <ng-container *ngIf="memberName; else pageTitleTemplate">{{ memberName }}</ng-container>
        <ng-template #pageTitleTemplate>{{ pageTitle | translate }}</ng-template>
      </h1>
    </ng-template>
    <ng-container *ngIf="isHomeBanner; else bannerLogoTemplate">
      <a class="banner-upgrade-cta" [routerLink]="['/membership']" *inProductCode="[productCode.Free]">
        {{ 'membership.upgrade.banner.cta' | translate : { fgbdefault: 'Upgrade Now' } }}
      </a>
      <img
        class="banner-logo"
        [src]="'logos/logowhite.png' | contentAssetImage"
        alt="Jets UK"
        *notInProductCode="[productCode.Free]"
      />
    </ng-container>
    <ng-template #bannerLogoTemplate>
      <img class="banner-logo" [src]="'logos/logowhite.png' | contentAssetImage" alt="Jets UK" />
    </ng-template>
  </div>
</div>


